/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Previous_Event_TitleInputs */

const en_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous Event`)
};

const fr_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement Precedent`)
};

const de_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Ereignis`)
};

const it_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento precedente`)
};

const ru_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущее событие`)
};

const es_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento anterior`)
};

const zh_cn2_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一活动`)
};

const ja_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前回のイベント`)
};

const hi_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला कार्यक्रम`)
};

const pt_pt2_player_previous_event_title = /** @type {(inputs: Player_Previous_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento anterior`)
};

/**
* | output |
* | --- |
* | "Previous Event" |
*
* @param {Player_Previous_Event_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_previous_event_title = /** @type {((inputs?: Player_Previous_Event_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Previous_Event_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_previous_event_title(inputs)
	if (locale === "de") return de_player_previous_event_title(inputs)
	if (locale === "it") return it_player_previous_event_title(inputs)
	if (locale === "ru") return ru_player_previous_event_title(inputs)
	if (locale === "es") return es_player_previous_event_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_previous_event_title(inputs)
	if (locale === "ja") return ja_player_previous_event_title(inputs)
	if (locale === "hi") return hi_player_previous_event_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_previous_event_title(inputs)
	return en_player_previous_event_title(inputs)
});